module.exports = __webpack_public_path__ + "img/wallpaper-tortelli-alle-erbette.13f871a6.png";